import { storageService } from '~/services'

export const state = () => ({
  status: null,
  deeplink: null,
  diiaStatus: null,
})

export const mutations = {
  setUserStatus(state, data) {
    state.status = data
    if (state.deeplink === null && data?.deeplink) {
      state.deeplink = data
    }
  },

  setDeeplink(state, data) {
    state.deeplink = data
  },

  setDiiaStatus(state, data) {
    state.diiaStatus = data
  },
}

export const actions = {
  async userStatus({ commit }) {
    const res = await this.$api.diia.getUserStatusDiia()
    commit('setUserStatus', res.data)
  },

  async deeplink({ commit }, { platform } = { platform: null }) {
    const res = await this.$api.diia.getDeeplinkDiia({ platform })
    storageService.setItem('diiaDeepLink', res.data)
    commit('setDeeplink', res.data)
  },

  async diiaStatus({ commit }) {
    const res = await this.$api.diia.getStatusDiia()
    commit('setDiiaStatus', res.data)
  },
}

export const getters = {
  getUserStatus: state => state.status,
  getDeeplink: state => state.deeplink,
  getDiiaStatus: state => state.diiaStatus,
}
